import { facilitiesApi } from "@apiService";
import * as types from "./types";

export const getFacilitiesData = (slug) => {
  return {
    type: types.GET_FACILITIES_DATA,
    payload: facilitiesApi.getFacilities(slug),
  };
};
